import { render, staticRenderFns } from "./elite-iq-banner-widget.vue?vue&type=template&id=440567d0"
import script from "./elite-iq-banner-widget.vue?vue&type=script&lang=ts"
export * from "./elite-iq-banner-widget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports